// Canonical public names taken from each course page's hero heading.
// Course headings, metadata, structured data, and analytics must reuse these values.
export const courseNames = Object.freeze({
  "/vibe-coding-bootcamp-with-claude/": "Vibe Coding Bootcamp",
  "/ai-business-automation-architect/": "AI Agent & Automation Bootcamp",
  "/work-automation-with-ai-agents/": "Work automation with AI Agents",
  "/machine-learning-and-ai-engineering-bootcamp/":
    "Deep Learning and Artificial Intelligence Engineering Bootcamp",
  "/barcelona-code-school/javascript-full-stack-bootcamp/":
    "Web / Mobile Development with AI full-time Bootcamp",
  "/barcelona-code-school/javascript-full-stack-online-bootcamp/":
    "Web / Mobile Development with AI part-time Bootcamp",
  "/game-development-bootcamp/": "Game Development full-time Bootcamp",
  "/game-development-online-bootcamp/": "Game Development part-time Bootcamp",
  "/ux-design-bootcamp-in-barcelona-code-school/":
    "UX/UI Design Bootcamp with AI",
  "/ux-design-online-mentored-bootcamp/":
    "UX/UI Design part-time Bootcamp with AI",
  "/ai-compliance-training/": "AI Act Compliance Training",
  "/ai-compliance-training-es/":
    "Formación en Cumplimiento de la Ley de IA",
  "/bcs-young-coders-summer-camp-2026/":
    "BCS Young Coders Summer Camp 2026",
  "/design-and-prototype-in-figma/": "Figma Crash Course",
  "/branding-in-ux-ui-design-workshop/": "Branding in UX/UI workshop",
  "/responsive-web-design-with-css3/": "Responsive web design with CSS3",
  "/programming-with-javascript/": "Programming with JavaScript",
  "/reactjs-crash-course/": "React.js Crash Course",
  "/backend-development-with-node-express-mongodb/":
    "Back-end Development with Node, Express, MongoDB",
  "/corporate-training/": "AI for companies",
  "/n8n-course/": "n8n Course",
  "/ai-agents-builder-course/": "AI Agents Builder",
  "/ai-agents-builder-course-es/":
    "Curso de agentes de IA para el trabajo y los negocios",
});
